import React from 'react';
import './UIBadge.scss';

export type BadgeVariant = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';
export type BadgeShape = 'default' | 'pill' | 'rounded';

export interface UIBadgeProps {
  /**
   * Варіант кольору бейджа
   */
  variant?: BadgeVariant;

  /**
   * Форма бейджа
   */
  shape?: BadgeShape;

  /**
   * Текст бейджа
   */
  children: React.ReactNode;

  /**
   * Додатковий CSS клас
   */
  className?: string;
}

const baseClass = 'UIBadge';

const UIBadge: React.FC<UIBadgeProps> = ({
                                           variant = 'primary',
                                           shape = 'default',
                                           children = 'Badge',
                                           className = ''
                                         }) => {
  const badgeClasses = [
    baseClass,
    `${baseClass}--${variant}`,
    shape !== 'default' && `${baseClass}--${shape}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={badgeClasses}>
      {children}
    </span>
  );
};

export default UIBadge;